import { render, staticRenderFns } from "./FocusPointEditor.vue?vue&type=template&id=d8cd82a8&class=focus-point-modal"
import script from "./FocusPointEditor.vue?vue&type=script&lang=js"
export * from "./FocusPointEditor.vue?vue&type=script&lang=js"
import style0 from "./FocusPointEditor.vue?vue&type=style&index=0&id=d8cd82a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports